import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const ProductsPage = lazy(() => import('../pages/products/page'));
const AIToolsPage = lazy(() => import('../pages/ai-tools/page'));
const BlogPage = lazy(() => import('../pages/blog/page'));
const BlogDetailPage = lazy(() => import('../pages/blog/detail/page'));
const RequestQuotePage = lazy(() => import('../pages/request-quote/page'));
const ResourcesPage = lazy(() => import('../pages/resources/page'));
const PUBeltManufacturersPage = lazy(() => import('../pages/pu-belt-manufacturers-directory/page'));
const IndiaSupplierDirectoryPage = lazy(() => import('../pages/india-supplier-directory/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/services',
    element: <ServicesPage />,
  },
  {
    path: '/products',
    element: <ProductsPage />,
  },
  {
    path: '/ai-tools',
    element: <AIToolsPage />,
  },
  {
    path: '/blog',
    element: <BlogPage />,
  },
  {
    path: '/blog/:slug',
    element: <BlogDetailPage />,
  },
  {
    path: '/request-quote',
    element: <RequestQuotePage />,
  },
  {
    path: '/resources',
    element: <ResourcesPage />,
  },
  {
    path: '/pu-belt-manufacturers-directory',
    element: <PUBeltManufacturersPage />,
  },
  {
    path: '/india-supplier-directory',
    element: <IndiaSupplierDirectoryPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;